import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';
import type { Role } from '../types/roles.type';

export const UpdateRoleSchema = z.object({
  role: z
    .string()
    .min(1, { message: 'Nama role tidak boleh kosong!' })
    .optional(),
  permissions: z.array(z.string()).optional(),
});

export type UpdateRoleData = z.infer<typeof UpdateRoleSchema>;

export type UpdateRolePayload = {
  roleId: string;
  data: UpdateRoleData;
};

export type UpdateRoleResponse = ApiResponse<Role>;

export const updateRole = async (
  payload: UpdateRolePayload
): Promise<UpdateRoleResponse> => {
  const { roleId, data } = payload;
  const url = `/role/${roleId}`;

  return await apiClient.patch(url, data);
};

export function updateRoleMutationOptions() {
  return mutationOptions<UpdateRoleResponse, AxiosError, UpdateRolePayload>({
    mutationFn: updateRole,
  });
}
